// js/module/lazyLoader.js
function lazyLoader() {
  const videos = document.querySelectorAll('video[data-src]');
  if (!videos.length) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;

        if (video.dataset.src) {
          video.src = video.dataset.src;
          video.removeAttribute('data-src');
          video.load();

          if (video.autoplay) {
            video.play().catch(() => {});
          }
        }

        observer.unobserve(video);
      }
    });
  }, {
    rootMargin: '50px 0px',
    threshold: 0.1
  });

  videos.forEach(video => {
    observer.observe(video);
  });
}

export default lazyLoader;
